
        var result = require("!!../../../../node_modules/css-loader/index.js!./settings-security.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-security/settings-security.component.css
// module id = 2436
// module chunks = 1